import React from "react";

interface VideoSuggestionsProps {
  video: any;
  open: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setVideo: React.Dispatch<
    React.SetStateAction<{
      title: string;
      src: string;
      type?: string;
    }>
  >;
}

const NetaVideos: React.FC<VideoSuggestionsProps> = (
  props: VideoSuggestionsProps
) => {
  console.log(props.video);

  return (
    <div
      key={props.video.id}
      className="bg-white rounded-lg shadow hover:shadow-md transition duration-300"
      onClick={() => {
        props.setVideo({
          src: props.video.link,
          title:
            "বাংলার যে উন্নত শহর ইবনে বতুতাকে মুগ্ধ করেছিল | Ibn Battuta in Bengal | Labid Rahat",
          type: props.video?.videoType || "YOUTUBE",
        });
        props.setIsOpen(true);
      }}
    >
      <div className="relative">
        <img
          src={
            props.video?.thumbnail ||
            `https://i4.ytimg.com/vi/${props.video.video_id}/hqdefault.jpg`
          }
          alt={props.video.title}
          className="w-full h-40 object-cover rounded-t-lg"
        />
        <span className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded">
          {props.video.duration || 0} mins
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-gray-800 line-clamp-2">
          {props.video.title}
        </h3>
      </div>
    </div>
  );
};

export default NetaVideos;
